import { useState, useEffect } from "react";

/**
 * Custom hook to detect and track screen width with debouncing
 * @returns {number} Current screen width in pixels
 */
const useScreenWidth = (): number => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setWidth(window.innerWidth);
      }, 100); // Debounce for 100ms
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return width;
};

export default useScreenWidth;
